import React, { useState, useEffect } from "react";
import PageHeader from "../components/ui/PageHeader";
import PurchaseInvoiceList from "../components/purchases/PurchaseInvoiceList";
import PurchaseInvoiceForm from "../components/purchases/PurchaseInvoiceForm";
import PurchaseInvoiceDetail from "../components/purchases/PurchaseInvoiceDetail";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";

const PurchaseInvoicesPage = () => {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("new") === "true") {
      setShowForm(true);
    }
  }, [searchParams]);

  const handleView = (invoice) => {
    navigate(`/purchases/${invoice.id}`);
  };

  const handleEdit = (invoice) => {
    setEditingInvoice(invoice);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingInvoice(null);
    setRefreshKey((k) => k + 1);
  };

  if (invoiceId) {
    return <PurchaseInvoiceDetail invoiceId={invoiceId} onEdit={handleEdit} />;
  }

  return (
    <Box>
      <PageHeader
        title="Compras / Gastos"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingInvoice(null);
              setShowForm(true);
            }}
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: "none",
              color: "#fff",
              "&:hover": {
                boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
                filter: "brightness(1.05)",
              },
            }}
          >
            Nueva Factura de Compra
          </Button>
        }
      />
      <PurchaseInvoiceList
        key={refreshKey}
        onView={handleView}
        onEdit={handleEdit}
      />

      <Dialog
        key={editingInvoice?.id || "new"}
        open={showForm}
        onClose={() => {
          setShowForm(false);
          setEditingInvoice(null);
        }}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <PurchaseInvoiceForm
            invoice={editingInvoice}
            onSave={handleSave}
            onCancel={() => {
              setShowForm(false);
              setEditingInvoice(null);
            }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default PurchaseInvoicesPage;
